import ReactGA from "react-ga4";

const GA_MEASUREMENT_ID = "G-H8RG4KQNC4";

let isInitialised = false;

const isTrackingEnabled = () => {
    return import.meta.env.MODE === "production" && Boolean((window as any).Cookiebot?.consent?.statistics);
};

export const initGA = () => {
    if (!isTrackingEnabled() || isInitialised) {
        return;
    }

    ReactGA.initialize(GA_MEASUREMENT_ID);
    isInitialised = true;
};

export const logPageView = (path: string) => {
    if (!isTrackingEnabled() || !isInitialised) {
        return;
    }

    ReactGA.send({ hitType: "pageview", page_path: path, page_location: window.location.href });
};

export const logEvent = (category: string, action: string, label?: string, value?: number) => {
    if (!isTrackingEnabled() || !isInitialised) {
        return;
    }

    ReactGA.event({ category, action, label, value });
};

export const disableGA = () => {
    if (!isInitialised) {
        return;
    }

    isInitialised = false;

    const gaCookies = ["_ga", `_ga_${GA_MEASUREMENT_ID.replace("G-", "")}`];
    gaCookies.forEach((name) => {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    });

    ReactGA.reset();
};